import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
  },
  listItem: {
    width: '100%',
    padding: '0 4px 0 0',
    borderBottom: `1px solid ${theme.palette.common.greyLight}`,

    '&:last-child': {
      border: 0,
    },
  },
  divider: {
    margin: '1rem -2rem 1rem',
  },
  name: {
    fontWeight: 500,
  },
  link: {
    '& a': {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
  status: {
    fontSize: '0.75rem',
    borderRadius: 2,
    color: '#fff',
    fontWeight: 500,
    padding: '6px 16px !important',
  },
  NONE: {
    backgroundColor: theme.palette.primary.main,
  },
  FAIL: {
    backgroundColor: theme.palette.error.main,
  },
  PREAUTH: {
    backgroundColor: theme.palette.primary.main,
  },
  DISPUTED: {
    backgroundColor: theme.palette.error.main,
  },
  COMPLETE: {
    backgroundColor: theme.palette.status.active,
  },
  REFUNDED: {
    backgroundColor: theme.palette.status.active,
  },
  INPROGRESS: {
    backgroundColor: theme.palette.primary.main,
  },
  PREAUTHREFUNDED: {
    backgroundColor: theme.palette.error.main,
  },
  FAILED: {
    backgroundColor: theme.palette.error.main,
  },
  SUCCEEDED: {
    backgroundColor: theme.palette.status.active,
  },
}));

const listTextStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    primary: {
      color: theme.palette.text.subtitle,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: 'bold',
      wordBreak: 'break-word',
    },

    secondary: {
      color: theme.palette.common.lightNavy,
      fontSize: theme.typography.pxToRem(13),
      wordBreak: 'break-word',
    },
  };
});

const collapseCardStyles = makeStyles((theme) => ({
  root: {
    marginTop: 0,
    marginBottom: 20,
    '& button': {
      borderRadius: 4,
    },
  },
  box: {
    marginTop: 0,
    borderTop: 0,
    borderRadius: '0 0 4px 4px',
  },
  buttonClass: {
    backgroundColor: theme.palette.tables.header,
    border: `1px solid ${theme.palette.dividers.primary}`,
    boxShadow: 'none',
    color: theme.palette.widgets.text.primary,
    padding: '6px 24px',
    textTransform: 'capitalize',
    fontSize: '13px',
    '&:hover': {
      backgroundColor: theme.palette.tables.header,
      border: `1px solid ${theme.palette.dividers.primary}`,
      boxShadow: 'none',
      color: theme.palette.widgets.text.primary,
    },
  },
}));

export { useStyles, listTextStyles, collapseCardStyles };
